import { type AiOfferDTO, type AiOfferReadRequestFEDTO } from 'ecosystem'
import { arrayFindAndUpdateItem } from 'shared-utils'
import { baseSplitApi, type BaseSplitApiExtendable } from '../../store-utils'

export const generateReadAiOfferEndpoint = <T extends BaseSplitApiExtendable>(rtkBaseApi: T) => {
  return rtkBaseApi.injectEndpoints({
    endpoints: (builder) => ({
      readAiOffer: builder.mutation<void, AiOfferReadRequestFEDTO>({
        query: ({ offerId }) => ({
          url: `ai-offers/read-offer`,
          method: 'POST',
          body: {
            offerId
          }
        }),
        onQueryStarted: async ({ offerId, sessionId }, { queryFulfilled, dispatch }) => {
          try {
            dispatch(
              rtkBaseApi.util.updateQueryData(
                // @ts-expect-error -- name of endpoint
                'getAiOffers',
                { sessionId },
                (offers: AiOfferDTO[]) => {
                  if (Array.isArray(offers)) {
                    arrayFindAndUpdateItem({
                      arr: offers,
                      compare: (offer) => offer.id === offerId,
                      cb: (offer) => {
                        offer.opened = true
                      }
                    })
                  }
                }
              )
            )

            await queryFulfilled
          } catch (_e) {
            /* empty */
          }
        }
      })
    }),
    overrideExisting: true
  })
}

export const readAiOfferEndpoint = generateReadAiOfferEndpoint(baseSplitApi)

export const { useReadAiOfferMutation } = readAiOfferEndpoint
